module.exports = __webpack_public_path__ + "static/media/list-active.bacd3265.svg";